export default __webpack_public_path__ + "60422f85a49cd43675f64e33e16d4924.png";